module.exports = __webpack_public_path__ + "img/contractor-roles.37b581da.svg";